import React, { useState, useEffect } from "react";
import { contractApi } from "../api/contractApi";
import { laneApi } from "../api/laneApi";
/* eslint-disable no-unused-vars */
import { routeApi } from "../api/routeApi";
import { rateApi } from "../api/rateApi";
import ContractsDetails from "../tabs/ContractsDetails";
import LanesDetails from "../tabs/LanesDetails";
import RoutesDetails from "../tabs/RoutesDetails";
import RatesDetails from "../tabs/RatesDetails";

const searchConfigs = {
  contract: {
    label: "Contracts",
    component: ContractsDetails,
    api: contractApi.searchContracts,
    columns: [
      { header: "Contract Code", dataKey: "contractCode" },
      { header: "Status", dataKey: "status" },
      { header: "Office Code", dataKey: "officeCode" },
      {
        header: "Effective Date",
        dataKey: "effectiveDate",
        format: (value) =>
          value == null ? "-" : new Date(value).toLocaleDateString(),
      },
      {
        header: "Expiration Date",
        dataKey: "expirationDate",
        format: (value) =>
          value == null ? "-" : new Date(value).toLocaleDateString(),
      },
    ],
  },
  lane: {
    label: "Lanes",
    component: LanesDetails,
    api: laneApi.searchLanes,
    columns: [
      { header: "Lane Code", dataKey: "laneCode" },
      { header: "Office Code", dataKey: "officeCode" },
      { header: "Origin", dataKey: "origin" },
      { header: "Destination", dataKey: "destination" },
    ],
  },
  route: {
    label: "Routes",
    component: RoutesDetails,
    api: routeApi.searchRoutes,
    columns: [
      { header: "Route Code", dataKey: "routeCode" },
      { header: "Origin", dataKey: "origin" },
      { header: "Destination", dataKey: "destination" },
      { header: "Carrier", dataKey: "carrier" },
      { header: "Shipper", dataKey: "shipper" },
    ],
  },
  rate: {
    label: "Rates",
    component: RatesDetails,
    api: rateApi.searchRates,
    columns: [
      { header: "Rate Code", dataKey: "rateCode" },
      { header: "Carrier", dataKey: "carrier" },
      { header: "Shipper", dataKey: "shipper" },
      { header: "Currency", dataKey: "currency" },
    ],
  },
};

const tabNameToSearchType = {
  "Contracts": "contract",
  "Lanes": "lane",
  "Routes": "route",
  "Rates": "rate",
};

const SearchResultsContainer = ({ searchTerm, activeTabData, officeCode }) => {
  const initialTab = tabNameToSearchType[activeTabData] || "contract";
  const [selectedTab, setSelectedTab] = useState(initialTab);

  useEffect(() => {
    const mappedTab = tabNameToSearchType[activeTabData];
    if (mappedTab) setSelectedTab(mappedTab);
  }, [activeTabData]);

  const currentConfig = searchConfigs[selectedTab];

  return (
    <div className="w-full h-full flex flex-col">
      {/* Sub-tab navigation */}
      <div className="shrink-0 border-b border-gray-200 dark:border-acs-dark-border bg-white dark:bg-acs-dark-surface">
        <div className="flex space-x-8">
          {Object.entries(searchConfigs).map(([key, config]) => (
            <button
              key={key}
              onClick={() => setSelectedTab(key)}
              className={`px-1 py-4 text-sm font-medium ${
                selectedTab === key
                  ? "text-blue-600 border-b-2 border-blue-600"
                  : "text-gray-500 hover:text-gray-700 hover:border-gray-300"
              }`}
              role="tab"
              aria-selected={selectedTab === key}
            >
              {config.label}
            </button>
          ))}
        </div>
      </div>

      {/* Content area */}
      <div className="h-full min-h-0 overflow-hidden flex flex-col">
        {currentConfig.component ? (
          <currentConfig.component
            searchTerm={searchTerm}
            officeCode={officeCode}
            fetchFn={currentConfig.api}
            columns={currentConfig.columns}
            buildFilters={currentConfig.buildFilters}
          />
        ) : (
          <div className="p-8 text-center text-gray-500">
            Returned no search results for {currentConfig.label}.
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchResultsContainer;